import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import OfficeApi from '../api/office/office.ts';

export const fetchOfficesAsync = createAsyncThunk(
    'offices/fetchOffices',
    async () => {        
        const response = await OfficeApi();
        return response;
    }
);

const officeSlice = createSlice({
    name: 'offices',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder.addCase(fetchOfficesAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchOfficesAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchOfficesAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },

});

export default officeSlice.reducer;
